import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class SeoService {

  private readonly isBrowser!: boolean;

  constructor(
    private readonly meta: Meta, 
    private readonly title: Title, 
    @Inject(PLATFORM_ID) private readonly platformId: Object,
    @Inject(DOCUMENT) private readonly doc: Document
  ) 
    {
      this.isBrowser = isPlatformBrowser(platformId);
    }

  setMetaTags(config: {
    title: string;
    description: string;
    keywords?: string;
    image?: string;
    url?: string;
  }) {

    const url = config.url || (this.isBrowser ? window.location.href : 'https://default-url.com');

    this.setTitle(config.title);
    this.updateMetaTag('description', config.description);
    this.updateMetaTag('keywords', config.keywords || 'default keywords');
    this.updateOgTag('og:title', config.title);
    this.updateOgTag('og:description', config.description);
    this.updateOgTag('og:image', config.image || 'default-image.jpg');
    this.updateOgTag('og:url', url); 
  }

  private setTitle(title: string) {
    this.title.setTitle(`${title}`); 
  }

  private updateMetaTag(name: string, content: string) {
    if (content) {
      this.meta.updateTag({ name, content });
    }
  }

  private updateOgTag(property: string, content: string) {
    if (content) {
      this.meta.updateTag({ property, content });
    }
  }
}